import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ImageIds } from 'src/common/models/message';
import { media } from 'src/common/styles/breakpoints';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import {
  ScreenScrapeForm,
  ScreenScrapeFormFooter,
} from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeForm';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { filterChecked } from 'src/pages/AspspSelectPage/ScreenScrape/common/filterChecked';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { Checkbox } from 'src/pages/MainPage/components/ConsentForm/Checkbox';
import styled, { css } from 'styled-components';

const StyledImg = styled.img<{ $selected?: boolean }>`
  height: 6.875rem;
  width: 6.875rem;
  object-fit: cover;

  ${(props) =>
    props.$selected &&
    css`
      border: 3px solid ${({ theme }) => theme.text.primary};
      border-radius: 0.25rem;
    `}
`;

const ImageContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 6.875rem);

  ${media.w.min.px576(css`
    grid-template-columns: repeat(auto-fit, minmax(6.875rem, 1fr));
  `)}

  column-gap: 0.5rem;
  row-gap: 0.5rem;
  justify-content: center;
  margin-bottom: 3rem;
`;

const StyledCheckbox = styled(Checkbox)`
  visibility: hidden;
`;

type ChooseImageFormModel = Record<string, boolean | undefined>;

export const ScreenScrapeImageIds = () => {
  const ctx = useSSContext();
  const [valid, setValid] = useState(false);

  const { control, handleSubmit, watch, getValues, setValue, reset } =
    useForm<ChooseImageFormModel>();

  const imageIds = ctx.lastJsonMessage?.object as ImageIds;

  useEffect(() => {
    const subscription = watch((value) => {
      setValid(filterChecked(value).length > 0);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (formValues: ChooseImageFormModel) => {
    if (valid) {
      const body = filterChecked(formValues).flatMap((entry) => entry[0]);

      ctx.submitStep(null, body);
    }
  };

  return ctx.isLoading ? (
    <ScreenScrapeLoader />
  ) : (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeForm onSubmit={handleSubmit(onSubmit)}>
        <ImageContainer>
          {imageIds.details.map((image) => {
            return (
              <label key={image.imageId}>
                <Controller
                  key={image.imageId}
                  name={`${image.imageId}` as const}
                  control={control}
                  render={({ field }) => (
                    <div>
                      <StyledCheckbox
                        {...field}
                        onChange={(v) => {
                          if (imageIds.chooseOneImage) {
                            reset();
                          }

                          setValue(image.imageId, v);
                        }}
                      />
                      <StyledImg
                        src={image.url}
                        $selected={getValues(image.imageId)}
                      />
                    </div>
                  )}
                />
              </label>
            );
          })}
        </ImageContainer>
        <ScreenScrapeFormFooter>
          <ScreenScrapeButton type="submit" disabled={!valid}>
            Potwierdź
          </ScreenScrapeButton>
        </ScreenScrapeFormFooter>
      </ScreenScrapeForm>
    </>
  );
};
